import { assoc } from 'ramda';

const notdoneMapper = (data) => {
    const contacts = data.contacts.map((item, index) => {
        return assoc('number', data.line + index, item);
    });

    return { ...data, contacts };
}

export default notdoneMapper;
